import { render, staticRenderFns } from "./d-book-gallery.vue?vue&type=template&id=398f0b7a&"
import script from "./d-book-gallery.vue?vue&type=script&lang=js&"
export * from "./d-book-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports